<div class="row">
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Saturday and Sunday are not selectable</p>
    <input class="form-control" placeholder="Datepicker" bsDatepicker [daysDisabled]="[6,0]">
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Saturday and Sunday are selectable</p>
    <input class="form-control" placeholder="Datepicker" bsDatepicker>
  </div>
</div>


<div class="row">
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Saturday and Sunday are not selectable</p>
    <input class="form-control" placeholder="Daterangepicker" bsDaterangepicker [daysDisabled]="[6,0]">
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Saturday and Sunday are selectable</p>
    <input class="form-control" placeholder="Daterangepicker" bsDaterangepicker>
  </div>
</div>
